import {SlButton, SlDialog, SlRadioGroup, SlRadioButton} from '../../../../vendor/plugins/clxFrontendCms/public/js/shoelace/shoelace';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';

export class StepByStep {
    private readonly viewRoot: HTMLElement;
    private readonly openLayerLink: HTMLAnchorElement | null;
    private readonly layer: SlDialog | null;
    private readonly layerPraemienBox: SlDialog | null;
    private readonly SAVE_MICRO_ACTION = '/tarif/save_microconversion';
    private readonly SAVE_MICRO_TYP = 'stepbystep';

    constructor(viewroot: HTMLElement) {
        this.viewRoot = viewroot;
        this.openLayerLink = this.viewRoot.querySelector('.open-step-box');
        this.layer = this.viewRoot.querySelector('.layer-step-box');
        this.layerPraemienBox = this.viewRoot.querySelector('.layer-praemen-box');

        this.registerEventListeners();
    }

    private registerEventListeners(): void {
        if (!this.layer || !this.openLayerLink) {
            return;
        }

        const layer = this.layer;
        const openLayerLink = this.openLayerLink;

        // oeffne den layer
        openLayerLink.addEventListener('click', (event) => {
            event.preventDefault();

            this.saveMircoconversion(openLayerLink);
            this.resetLayer(layer);
            layer.show();

            if (this.layerPraemienBox) {
                if (this.layerPraemienBox.open) {
                    this.layerPraemienBox.hide();
                }
            }
        });

        const summeryContainer = notNull(layer.querySelector<HTMLDivElement>('.summery-container'));

        const nextButton = notNull(layer.querySelector<HTMLDivElement>('.button-container sl-button'));

        const currentRouterID = notNull(layer.querySelector<HTMLInputElement>('#routerID'));
        const currentRepeaterID = notNull(layer.querySelector<HTMLInputElement>('#repeaterID'));
        const currentMenge = notNull(layer.querySelector<HTMLInputElement>('#menge'));
        const currentStep = notNull(layer.querySelector<HTMLInputElement>('#currentStep'));

        // Auswahl zuruecksetzen in diesen step
        const reset = notNull(layer.querySelectorAll<HTMLAnchorElement>('.reset'));
        reset.forEach((resetlink) => {
            resetlink.addEventListener('click', (event) => {
                event.preventDefault();

                this.resetLayer(layer);
            });
        });

        nextButton.addEventListener('click', (event) => {
            event.preventDefault();

            if (currentStep.value === 'clx-step-router-selection') {
                this.switchStep(layer, 'clx-step-repeater-selection');
                summeryContainer.style.display = 'none';
                nextButton.setAttribute('disabled', 'disabled');
            } else if (currentStep.value === 'clx-step-repeater') {
                var art = 'stepbystep';
                var vtid = notNull(layer.dataset.tarifid);
                var routerID = notNull(layer.querySelector<HTMLInputElement>('#routerID')).value;
                var typ = notNull(layer.dataset.typ);
                var repeaterID = notNull(layer.querySelector<HTMLInputElement>('#repeaterID')).value;

                fetch('/tarif/select-praemie/' + vtid + '/' + art + '/' + routerID + '/' + typ + '/' + repeaterID, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    cache: 'default',
                    credentials: 'same-origin',
                })
                    .then((response) => response.json())
                    .then((data) => {
                        window.location.reload();
                    })
                    .catch((error) => console.error('Error:', error));
            }
        });

        // brauchst du einen router (ja oder nein) > springe zur routerauswahl oder zur infoseite
        const selectRouter = notNull(layer.querySelector<SlRadioGroup>('.router-select'));
        selectRouter.addEventListener('sl-change', (event) => {
            const targetRouter = event.target as SlRadioGroup;
            const needRouter = targetRouter.value;
            if (needRouter === 'ja') {
                this.switchStep(layer, 'clx-step-router-selection');
                summeryContainer.style.display = 'block';
            } else if (needRouter === 'nein') {
                this.switchStep(layer, 'clx-step-note-connection');
                summeryContainer.style.display = 'none';
            }
        });

        // routerauswahl
        const routerSelectionGroup = notNull(layer.querySelector<SlRadioGroup>('.router-selection-group'));
        routerSelectionGroup.addEventListener('sl-change', (event) => {
            const target = event.target as SlRadioGroup;
            const selectedValue = target.value;

            nextButton.removeAttribute('disabled');

            currentRouterID.value = selectedValue;

            this.fetchSummery(layer);
        });

        // brauchst du einen repeater (ja oder nein) > springe zur routerauswahl oder zur infoseite
        const selectRepeater = notNull(layer.querySelector<SlRadioGroup>('.repeater-select'));
        selectRepeater.addEventListener('sl-change', (event) => {
            const targetRepeater = event.target as SlRadioGroup;
            const needRepeater = targetRepeater.value;
            if (needRepeater === 'ja') {
                this.switchStep(layer, 'clx-step-repeater');
                summeryContainer.style.display = 'block';
            } else if (needRepeater === 'nein') {
                var art = 'stepbystep';
                var vtid = notNull(layer.dataset.tarifid);
                var value = notNull(layer.querySelector<HTMLInputElement>('#routerID')).value;
                var typ = notNull(layer.dataset.typ);

                fetch('/tarif/select-praemie/' + vtid + '/' + art + '/' + value + '/' + typ, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    cache: 'default',
                    credentials: 'same-origin',
                })
                    .then((response) => response.json())
                    .then((data) => {
                        window.location.reload();
                    })
                    .catch((error) => console.error('Error:', error));
            }
        });

        // repeater auswahl
        const repeaterSelectionGroup = notNull(layer.querySelector<SlRadioGroup>('.repeater-selection-group'));
        repeaterSelectionGroup.addEventListener('sl-change', (event) => {
            const target = event.target as SlRadioGroup;
            const selectedValue = target.value;

            nextButton.removeAttribute('disabled');
            notNull(layer.querySelector<HTMLInputElement>('#menge')).value = '1';
            currentRepeaterID.value = selectedValue;
            this.fetchSummery(layer);
        });
    }

    private fetchSummery(layer: SlDialog) {
        const data = new FormData();
        data.append('tarifid', notNull(layer.dataset.tarifid));
        data.append('routerID', notNull(layer.querySelector<HTMLInputElement>('#routerID')).value);
        data.append('repeaterID', notNull(layer.querySelector<HTMLInputElement>('#repeaterID')).value);
        data.append('menge', notNull(layer.querySelector<HTMLInputElement>('#menge')).value);

        fetch('/dsl/api_step_by_step_summery', {
            method: 'POST',
            body: data,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok.');
                }

                return response.text();
            })
            .then((content) => {
                const summeryContainer = notNull(layer.querySelector<HTMLDivElement>('.summery-container'));
                summeryContainer.innerHTML = content;
                summeryContainer.style.display = 'block';

                summeryContainer.scrollIntoView();
            });
    }
    private switchStep(layer: SlDialog, stepname: string): void {
        const allSteps = notNull(layer.querySelectorAll<HTMLDivElement>('.step'));
        allSteps.forEach((step) => {
            step.style.display = 'none';
        });

        const step = notNull(layer.querySelector<HTMLDivElement>(`.${stepname}`));
        step.style.display = 'block';

        const currentStep = notNull(layer.querySelector<HTMLInputElement>('#currentStep'));
        currentStep.value = stepname;
        step.scrollIntoView();

        const label = notNull(layer.querySelector<HTMLLabelElement>('#label-steps-container'));
        const labelcontent = notNull(step.querySelector<HTMLLabelElement>('.steps-container'));
        label.innerHTML = labelcontent.innerHTML;
    }

    private resetLayer(layer: SlDialog): void {
        const nextButton = notNull(layer.querySelector<HTMLDivElement>('.button-container sl-button'));
        nextButton.setAttribute('disabled', 'disabled');

        const allRadios = layer.querySelectorAll<SlRadioGroup>('sl-radio-group');
        allRadios.forEach((radio) => {
            radio.value = '0';
        });
        const allInputs = layer.querySelectorAll<HTMLInputElement>('input');
        allInputs.forEach((input) => {
            input.value = '';
        });

        this.fetchSummery(layer);
        this.switchStep(layer, 'clx-step-start');
    }

    private saveMircoconversion(element: HTMLAnchorElement): void {
        const formData = new FormData();
        formData.append('vtid', element.dataset.vtid ?? '');
        formData.append('typ', this.SAVE_MICRO_TYP);

        fetch(this.SAVE_MICRO_ACTION, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            cache: 'default',
            credentials: 'same-origin',
        });
    }
}
